import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import {
  PiCar,
  PiSquaresFour
} from "react-icons/pi";
import CategoryGrid, { CategoryGridItem } from "@/components/common/CategoryGrid/CategoryGrid";

interface IncomeGridItem extends CategoryGridItem {
  path: string;
}

const IncomesCategoryGrid = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleIncomeClick = (item: CategoryGridItem) => {
    const incomeItem = item as IncomeGridItem;
    navigate(incomeItem.path);
  };
  
  const incomeCategories: IncomeGridItem[] = [
    {
      id: "bolt",
      title: t('income.grid.bolt'),
      subtitle: t('income.grid.boltDesc'),
      icon: <PiCar className="h-4 w-4 text-zinc-700" />,
      path: "/bolt/balance",
      className: "flex-1 tour-category-item"
    },
    {
      id: "uber",
      title: t('income.grid.uber'),
      subtitle: t('income.grid.uberDesc'),
      icon: <PiCar className="h-4 w-4 text-zinc-700" />,
      path: "/uber/balance",
      className: "flex-1"
    },
    {
      id: "other",
      title: t('income.grid.other'),
      subtitle: t('income.grid.otherDesc'),
      icon: <PiSquaresFour className="h-4 w-4 text-zinc-700" />,
      path: "/income/create",
      className: "flex-1"
    }
  ];

  return (
    <CategoryGrid
      title={t('income.grid.title')}
      items={incomeCategories}
      onItemClick={handleIncomeClick}
      showToggle={false}
    />
  );
};

export default IncomesCategoryGrid;
